import { useSelector } from "react-redux";


const useOrganizationIsAllowed = (tag) =>{
    const {subscription} = useSelector(state=> state.organizationReducer.value);
    const {features} = useSelector(state=> state.subscriptionReducer.value);

    const feature_exists = features?.find(el=> el?.tag === tag);

    if(!feature_exists && features?.length > 0){
        const predata = {
            exists: true,
            feature: {}
        }
    
        return predata;
    }

    const isAllowed = subscription?.plan?.product?.features?.find(el=> el?.tag === tag);

    const data = {
        exists: isAllowed ? true : false,
        feature: isAllowed
    }

    return data;
}

export default useOrganizationIsAllowed;